<template>
  <section
    :class="[
      'new-rightLogin',
      { 'new-rightLogin-2': status === 5 && show },
      { 'close' : !show },
      { 'new-rightLogin-invite': invite }
     ]"
  >
    <div v-show="!invite">
      <div v-if="!show && clearClose" class="close" @click="close"></div>
      <p :class="['title', { p_60: !show && status < 5 }]">{{ titleObj[status] }}</p>
      <!-- 微信扫码登录注册 -->
      <NewWeixinLogin
        v-if="!invite"
        ref="NewWeixinLogin"
        v-show="status === 1"
        @BindingPhone="BindingPhone"
        @setUserLoginInfo="setUserLoginInfo"
      />
      <!-- 其他登录 -->
      <LoginBox
        v-show="status > 1"
        :isNew="true"
        :status="status"
        @setStatus="setStatus"
        ref="login"
        @selectIntent="selectIntent"
        @isOldUserFun="isOldUserFun"
        @closeDialog="close"
        @selectBody="selectBody"
      />
      <!-- 切换 -->
      <div class="tabs" v-if="status !== 5">
        <div class="left" @click="setStatus()">
          <img :src="status > 1 ? w_icon : a_icon" alt="">
          {{ status > 1 ? "微信登录" : "账号登录" }}
        </div>
        <div class="center"></div>
        <div class="right" @click="setStatus(status === 3 ? 2 : 3)">
          <img src="../../../assets/img@2x/l-phone.png" alt="">
          {{ status > 2 ? "账号登录" : "手机号登录" }}
        </div>
      </div>
      <div class="LogIn" v-else>
        想起密码？
        <el-button type="text" @click="setStatus()">去登录</el-button>
      </div>
    </div>

    <InviteMembers v-if="invite" @setLoginInfo="setLoginInfo"/>


    <div class="footer">
      <p>未注册手机号验证后自动登录，注册即同意
        <a :target="!show ? '_blank' : '_self'" :href="userAgreement">《用户协议》</a>和
        <a :target="!show ? '_blank' : '_self'" :href="privacyAgreement">《隐私协议》</a>
        </p>
    </div>
    <!-- 选择身份信息 -->
    <dialogCom
      :showIdentity="showIdentity"
      :showIdentity2="showIdentity2"
      @changeDialogShow="changeDialogShow"
      @setSuccess="setSuccess"
    />
    <!-- 完善信息 -->
    <improveDataCom
      ref="improveDataCom"
      @setSuccess="setSuccess"
    />

    <Firm :show.sync="showBody" :userId="userId" :sessionKey="sessionKey" />
  </section>
</template>

<script>
  import NewWeixinLogin from "./newWeixinLogin.vue"
  import LoginBox from "./loginBox.vue"
  import { mapGetters } from "vuex";
  import dialogCom from "./dialog";
  import improveDataCom from "./improveData.vue";
  import Firm from "./firm.vue";
  import SlsWebLogger from "js-sls-logger";
  // 请求模块
  import { updateUserInfo } from "../../../api/accountManage";
  import InviteMembers from "./inviteMembers.vue";

  export default {
    computed: {
      ...mapGetters(['userAgreement', 'privacyAgreement', 'timeRemaining', 'allow'])
    },
    components: {
      NewWeixinLogin,
      LoginBox,
      dialogCom,
      improveDataCom,
      Firm,
      InviteMembers
    },
    props: ["show"],
    data() {
      return {
        status: 1,
        titleObj: {
          "1": "微信扫码登录注册",
          "2": "账号密码登录",
          "3": "手机验证码登录",
          "4": "绑定手机号码",
          "5": "忘记密码"
        },
        w_icon: require("../../../assets/img@2x/l-WeChat.png"),
        a_icon: require("../../../assets/img@2x/l-account.png"),
        showIdentity: false, // 注册成功后必选修改身份弹框
        showIdentity2: false,
        userLoginInfo: null,
        wechatKey: null, // 微信绑定key
        identityList: [], // 选择的主体信息
        showBody: false,
        userId: null,
        sessionKey: null,
        clearClose: this.$route.query?.clearClose !== "true",
        invite: !!this.$route.query?.invite // 成员邀请
      }
    },
    created() {
      // 创建日志
      // eslint-disable-next-line no-undef
      window.log = new ULog({
        SlsWebLogger,
        env: process.env.NODE_ENV,
        delay: 1,
      });
    },
    methods: {
      // 选择主体
      selectBody(userId, sessionKey) {
        this.userId = userId;
        this.sessionKey = sessionKey;
        this.showBody = true;
      },
      // 选择身份
      selectIndentity(type) {
        if (type === 0) {
          this.identityList = [];
          this.identityList.push(type);
        } else {
          if (this.identityList.includes(0)) {
            this.identityList = [];
          }
          let isHas = this.identityList.find((item) => item === type);
          if (isHas) {
            for (let i = 0; i < this.identityList.length; i++) {
              if (this.identityList[i] === isHas) {
                this.identityList.splice(i, 1);
                break;
              }
            }
          } else {
            this.identityList.push(type);
          }
        }
      },
      // 设置身份
      async setIndentity() {
        if (this.identityList.length > 0) {
          this.btnLoading = true;
          let res = await updateUserInfo({
            identity: this.identityList.reduce((a, b) => Number(a) + Number(b))
          }).catch(() => {
            this.btnLoading = false;
          });
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "身份设置成功"
            });
            this.showIdentity = false;
            this.$refs["login"].loginInfoDispose({
              code: 1,
              data: this.userLoginInfo
            });
          }
          this.btnLoading = false;
        } else {
          this.$message({
            type: "warning",
            message: "请先选择身份",
          });
        }
      },
      // 当wechatKey有值时代表用户扫码成功，已经获取到用户的微信信息，跳转做绑定注册登录。
      BindingPhone(key) {
        // 359f1507-55e6-47d4-8bf1-706795c16d46
        this.wechatKey = key;
        this.$refs["login"].wechatKey = key;
        this.setStatus(4);
      },
      setStatus(n) {
        if (n) {
          this.status = n
        } else {
          if (this.status > 2) {
            this.nextTick(1);
            this.status = 1;
          } else {
            this.status = this.status === 1 ? 2 : 1;
          }
        }
        if (this.status === 3 || this.status === 4) {
          this.nextTick(2); // 切换验证码登录
        } else if (this.status === 1) {
          this.$nextTick(() => {
            this.$refs.NewWeixinLogin.getCode();
          });
        } else if (this.status === 2) {
          this.nextTick(1); // 切换账户登录
        }
        if (this.status !== 1) {
          this.$nextTick(() => {
            this.$refs.NewWeixinLogin.stop();
          });
        }
      },
      nextTick(n) {
        this.$nextTick(() => {
          this.$refs.login.switchWay(n);
        });
      },
      selectIntent(data) { // 是否选择意向 1已选择 0未选择
        this.showIdentity = true;
        this.userLoginInfo = data; // 登录信息
      },
      isOldUserFun(data) { // 判断是否是老用户
        this.$refs.improveDataCom.dialogVisible = true;
        this.userLoginInfo = data; // 登录信息
      },
      setUserLoginInfo(data) {
        this.$refs["login"].loginInfoDispose({
          code: 1,
          data: data,
        }, true);
      },
      setLoginInfo(res) {
        this.$refs["login"].loginInfoDispose(res, false);
      },
      changeDialogShow() {
        this.showIdentity2 = !this.showIdentity2;
      },
      setSuccess(n) {
        this.showIdentity = false;
        let data = this.userLoginInfo;
        if (n === 1) {
          data = {
            ...data,
            selectIntent: 1
          }
        }
        this.$refs["login"].loginInfoDispose({
          code: 1,
          data,
        }, true);
      },
      close() {
        // this.$refs.NewWeixinLogin.polling = false;
        window.top.postMessage({ type: "close" }, '*');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .new-rightLogin {
    .title {
      padding: 40px 0 0;
      font-size: 22px;
      font-weight: 600;
      color: #222222;
      line-height: 30px;
      text-align: center;
    }
    .tabs {
      margin: 0 115px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left,
      .right {
        font-size: 14px;
        font-weight: 500;
        color: #222222;
        line-height: 20px;
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
          vertical-align: middle;
          margin-right: 9px;
        }
      }
      .center {
        width: 1px;
        height: 16px;
        background: #EEEEEE;
      }
    }
    .LogIn {
      text-align: center;
      font-size: 14px;
      color: $gray;
      line-height: 20px;
      button {
        color: $primaryColor;
        padding: 0;
      }
    }
  }
  .new-rightLogin-2 {
    min-height: 570px;
  }
  .close {
    height: 540px;
    box-shadow: none;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    .title {
      padding-top: 26px;
    }
    .p_60 {
      padding-top: 60px;
    }
    .close {
      position: absolute;
      right: 20px;
      top: 21px;
      width: 18px;
      height: 18px;
      background-image: url(../../../assets/img/close.png);
      background-size: cover;
      cursor: pointer;
    }
    .footer {
      height: 46px;
      p {
        line-height: 46px;
      }
    }
  }
</style>